import { PROMO_ID_QUERYSTRING } from '../../../constants/promoIdQuery';
import { TSearchPromosResponse_1 } from '../../../repositories/newbuilding-promos/v2/search-promos';
import { RedirectError } from '../../../utils/errors/RedirectError';
import { removeSearchParam } from '../../../utils/url/removeSearchParam';

interface IParams {
  path?: string;
}

export function assertRedirectError(response: TSearchPromosResponse_1, { path }: IParams) {
  const cleanPath = removeSearchParam({ path, param: PROMO_ID_QUERYSTRING });

  if (cleanPath !== response.path) {
    throw new RedirectError({
      domain: 'shared/services/promosSearch/assert/assertRedirectError#assertRedirectError()',
      message: 'response path is different from requested path',
      location: response.path,
      statusCode: 301,
    });
  }
}
